import { compose, lensPath, set, view } from 'ramda'
import { isTrue } from 'ramda-adjunct'
import pipe from 'ramda/src/pipe'
import React, { useContext, useLayoutEffect } from 'react'
import { useLoaderData } from 'react-router'
import UserContext from '../../../context/UserContext'
import PageNavContainer from '../../../state/PageNavContainer'
import OldAppHeader from '../../AppModule/App/OldAppHeader'
import HubAccessTherapyPage from './HubAccessTherapyPage'
import RoutingContext from '../../../context/RoutingContext'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const PAGE_ID = `hub-about-therapy`

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const canAccessProgrammeLens = lensPath([`canAccessProgramme`])
const getCanAccessProgrammeLens = view(canAccessProgrammeLens)

const getEnrolmentCanAccessProgramme = pipe(getCanAccessProgrammeLens, isTrue)

const setPagesHubSleepImrovementPlanCardLinkUrl = set(
  compose(lensPath([`page`, `content`, `ctaButton`, `url`]))
)
const setPagesHubSleepImrovementPlanCardSecondaryLinkUrl = set(
  compose(lensPath([`page`, `content`, `ctaButtonSecondary`, `url`]))
)

const injectRouting = (routing, content) =>
  pipe(
    setPagesHubSleepImrovementPlanCardLinkUrl(routing.assessmentPath),
    setPagesHubSleepImrovementPlanCardSecondaryLinkUrl(routing.assessmentPath)
  )(content)

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const HubAboutTherapyModule = () => {
  const loaderData = useLoaderData()
  const [, setNav] = PageNavContainer.useContainer()
  const { currentEnrolment } = useContext(UserContext)
  const canEnrolmentAccessProgramme =
    getEnrolmentCanAccessProgramme(currentEnrolment)
  const { appRouting } = useContext(RoutingContext)
  const loaderDataWithRouting = injectRouting(appRouting, loaderData)

  useLayoutEffect(() => {
    setNav({
      pageId: PAGE_ID,
      Header: OldAppHeader,
    })
  }, [setNav])

  return (
    <HubAccessTherapyPage
      content={loaderDataWithRouting.page.content}
      canEnrolmentAccessProgramme={canEnrolmentAccessProgramme}
      currentEnrolment={currentEnrolment}
    />
  )
}

export default HubAboutTherapyModule
